import React, { useContext } from "react";
import SearchItem from "./SearchResultItem";
import { GlobalContext } from "../../Context/GlobalContext";
import { validateExpirationDate } from "../../utils/handlePremiereDates";

const Search = ({
  color,
  videos,
  searchTerm,
  viewerObj,
  setFile
}) => {
  const {darkMode} = useContext(GlobalContext);
  // filter out monetized content that the viewer isn't sub to
  const videosList = videos.filter(VideoObj => {
    const monetizedFile = VideoObj.metadata?.associatedSubscriptions
    const product_Id = viewerObj?.subscription?.product_Id; 
    const activeSub = monetizedFile?.hasOwnProperty(product_Id);

    if (validateExpirationDate(VideoObj?.premiereDate)) return;
    if(!monetizedFile) return VideoObj;
   
    
    // check if the file has any active subscriptions associated with it
    else if(Object.keys(monetizedFile).length === 0) return VideoObj;

    else if(activeSub) return VideoObj; 
  })
  .map(VideoObj => 
    (<SearchItem 
      key={VideoObj._id}
      color={color}
      VideoObj={VideoObj}
      searchTerm={searchTerm}
      setFile={() => setFile(VideoObj)}/>)
  )
  return (
    <div className={darkMode?'dark vh container mt-3':"container mt-3"}>
      {/* video search results */}
      
      {videosList.length !== 0 ? videosList : <p> No videos matching <strong>{searchTerm}</strong>...</p>}
    </div>
  );
  
}

export default Search;
